module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/32baed9307dd0a57fd31de5c863f6f49.png";